import { useEffect, useRef } from 'react';
import { normalizeCartLines } from '@shopgnd/shared';
import { listPendingCardPaymentOrders } from '@/api/orders';
import { useAuthStore } from '@/stores/authStore';
import { useCartStore } from '@/stores/cartStore';
import { useNotificationStore } from '@/stores/notificationStore';

/**
 * If the buyer already has unpaid card orders, a full cart would double-reserve stock
 * on the next checkout attempt. Clear stale cart lines and nudge them to Orders.
 */
export function useStaleCartGuard() {
  const user = useAuthStore((s) => s.user);
  const lines = useCartStore((s) => normalizeCartLines(s.lines));
  const clear = useCartStore((s) => s.clear);
  const push = useNotificationStore((s) => s.push);
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (!user || lines.length === 0) {
      notifiedRef.current = false;
      return;
    }

    void listPendingCardPaymentOrders(user.id).then((pending) => {
      if (pending.length === 0) {
        notifiedRef.current = false;
        return;
      }
      clear();
      if (!notifiedRef.current) {
        notifiedRef.current = true;
        push({
          title: 'Unpaid order in progress',
          body: 'Your cart was cleared so inventory is not reserved twice. Open Your orders to complete payment.',
          tone: 'error',
        });
      }
    });
  }, [user, lines.length, clear, push]);
}
